import * as React from 'react';
import styled from 'styled-components';

import { useLinks, useModalSettingsContext, usePostMessageContext } from 'src/providers';

import Button from 'src/components/Button';

import { ReactComponent as ExternalLink } from 'src/images/external-link.svg';

const StyledFooter = styled.div`
  display: flex;
  align-items: center;
  font-size: 16px;
  color: var(--dark-gray);

  .faq {
    text-decoration: underline;

    &:focus {
      outline: revert;
      color: #000000;
    }
    &:hover {
      color: #000000;
    }
  }

  .separator {
    margin: 0 1em;
    cursor: default;
    user-select: none;
  }

  .tncs {
    display: flex;
    align-items: center;
    color: inherit;

    svg {
      margin: 0 0 0 0.5em;
    }

    &:focus, &:hover {
      color: #000000;
    }
  }
`;

interface IFooterProps {
  className?: string;
  onFAQClicked: React.MouseEventHandler<HTMLButtonElement>;
}

export function Footer(props: IFooterProps) {
  const { className, onFAQClicked } = props;
  const { terms: termsLink } = useLinks();
  const { postMessage } = usePostMessageContext();
  const { modalType } = useModalSettingsContext();

  return (
    <StyledFooter className={className}>
      <Button className='faq' data-test="faq" onClick={onFAQClicked}>
        FAQ
      </Button>

      <span className="separator">|</span>

      <a
        className="tncs"
        data-test="tncs"
        href={termsLink}
        onClick={() => postMessage('seeTermsAndConditions', { ctaType: 'modal', modalType })}
        rel="noreferrer"
        target="_blank"
      >
        Terms &amp; Conditions
        <ExternalLink />
      </a>
    </StyledFooter>
  );
}
